module.exports = __webpack_public_path__ + "static/main-4ae062c1bb8e188ebd1e0e9df1bff763.jpg";